import { useEffect, useMemo, useState, useCallback } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadFireworksPreset } from "@tsparticles/preset-fireworks";

const FireworksBackground = () => {
  const [engineReady, setEngineReady] = useState(false);
  useEffect(() => {
    const initEngine = async () => {
      await initParticlesEngine(async (engine) => {
        await loadFireworksPreset(engine);
        engine.addPreset("custom-fireworks", {});
      });
      setEngineReady(true);
    };

    initEngine().catch(console.error);

    return () => {
      setEngineReady(false);
    };
  }, []);

  const handleParticlesLoaded = useCallback((container) => {}, []);

  const optimizedOptions = useMemo(
    () => ({
      preset: "fireworks",
      sounds: {
        enable: [],
        events: [],
      },
      fpsLimit: 60,
      smooth: true,
      detectRetina: true,
      motion: { reduce: { factor: 4 } },
      fullScreen: { enable: false },
    }),
    []
  );

  return engineReady ? (
    <div className="fireworks-container">
      <Particles
        id="tsparticles"
        particlesLoaded={handleParticlesLoaded}
        options={optimizedOptions}
      />
    </div>
  ) : null;
};

export default FireworksBackground;
